import React, { FC, useLayoutEffect, useRef, useState } from 'react';
import ToolTip from 'components/ToolTip/ToolTip';

type TNavLabelProps = {
  text?: string;
};

/* A side panel label that only explains itself when it has to: the panel is a
   fixed 256px, so a long route name is ellipsised, and the tooltip appears just
   for those. Showing one on every row would repeat text the user can read.

   The measurement has to settle before the pointer arrives — antd forces a
   tooltip hidden while its title is empty, so deciding on hover would leave the
   first hover silent. A ResizeObserver keeps it right as the panel collapses,
   the window resizes, or a submenu opens. */
const NavLabel: FC<TNavLabelProps> = ({ text = '' }) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [truncated, setTruncated] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const measure = () => setTruncated(el.scrollWidth > el.clientWidth + 1);
    measure();

    if (typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
  }, [text]);

  return (
    <ToolTip placement="right" title={truncated ? text : ''}>
      <span className="nav-label" ref={ref}>
        {text}
      </span>
    </ToolTip>
  );
};

export default NavLabel;
